<script>
import validateCPF, { validateCNPJ } from '@/utils/validate_cpf';
import { Validator } from 'vee-validate';
import service from '@/services';
import formatToBRL from '@/utils/formatNumberToBRL';
import DateConversion from '@/utils/dateConversion';
import vSelect from 'vue-select';

export default {
  data() {
    return {
      cpfCnpj: null,
      placa: null,
      boletos: [],
      tipoDocumento: 'CPF',
      boletoCopiado: null,
    }
  },
  computed: {
    dateConversion() {
      return DateConversion
    }
  },
  methods: {
    formatToBRL,
    async getBoleto() {
      try {
        this.limparBoletos()

        const valid = await this.$validator.validateAll()

        if (!valid){
          return
        }

        const dadosBoletos = await service.post(
          'segunda-via-boleto',
          'beneficiario',
          {
            cpfCnpj: this.cpfCnpj,
            placa: this.placa
          }
        )

        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: "Boletos encontrados com sucesso!",
          color: 'success',
          time: 5000,
        });

        this.boletos = dadosBoletos.data
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: "Não foi possível encontrar boletos para os dados informados.",
          color: 'danger',
          time: 5000,
        });
      }
    },
    validateState(ref) {
      const field = this.veeFields[ref];
      return field && (field.dirty || field.validated) ? !this.veeErrors.has(ref) : null;
    },
    validateClass(ref) {
      const field = this.veeFields[ref];
      return field && (field.dirty || field.validated) ? this.veeErrors.has(ref) : null;
    },
    openBoleto(url) {
      if (url.endsWith('.pdf')) {
        window.open(`https://docs.google.com/viewer?url=${url}&embedded=true`, '_blank');
        return
      }
      window.open(url, '_blank');
    },
    limparBoletos() {
      this.boletos = []
    },
    adicionarRegraValidacaoCPF() {
      Validator.extend('CPF', {
        getMessage: `O campo deve conter um CPF válido.`,
        validate: value => value.trim() !== '' && validateCPF(value)
      });
    },
    adicionarRegraValidacaoCNPJ() {
      Validator.extend('CNPJ', {
        getMessage: `O campo deve conter um CNPJ válido.`,
        validate: value => value.trim() !== '' && validateCNPJ(value)
      });
    },
    async copiarParaAreaDeTransferencia(text, idBoleto) {
      try {
        await navigator.clipboard.writeText(text);
        this.$vs.notify({
          position: 'top-center',
          title: 'Sucesso',
          text: 'Linha digitável copiada com sucesso!',
          color: 'success',
          time: 3000,
        });
        this.boletoCopiado = idBoleto;
      } catch (err) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Erro',
          text: 'Erro ao copiar linha digitável.',
          color: 'danger',
          time: 3000,
        });
      }
    }

  },
  mounted() {
    this.adicionarRegraValidacaoCPF()
    this.adicionarRegraValidacaoCNPJ()
  },
  watch: {},
  components: {
    'v-select': vSelect
  },
}
</script>

<style scoped lang="scss">
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');
</style>

<style>
.boletosCard > div {
  margin-bottom: 0 !important;
}

.tipoPessoaSelect > div {
  height: 38px;
}

.no-wrap-button {
  white-space: nowrap;
}

</style>

<template>
  <div>
    <div class="flex flex-row flex-nowrap justify-around items-center mb-1 my-5">
      <H1 class="lg:text-4xl text-xl font-bold text-[#114880]">Área do Cliente</H1>
      <img src="https://s3.amazonaws.com/bboneapp/Upload/logo/123/1717423126775_120(4).png" alt="logo" class="lg:w-52 w-32" />
    </div>
    <div class="flex flex-row flex-nowrap justify-center items-center">
      <div class="lg:w-3/4 w-full">
        <vs-row>
          <vs-col>
            <vs-card>
              <div class="flex flex-col flex-nowrap justify-center items-center">
                <div>
                  <div>
                    <h3 class="lg:text-2xl text-base text-[#434343] pb-9 mt-5">Para acessar sua área de pagamentos</h3>
                  </div>
                </div>
                <div class="flex flex-col w-full flex-nowrap justify-center items-center lg:w-1/2">
                  <vs-row class="m-2">
                    <vs-col class="m-2 flex flex-nowrap justify-center items-center w-full mt-5">
                      <div class="flex w-full gap-3 lg:flex-row-reverse flex-col-reverse">
                        <vs-input
                          id="CPF/CNPJ"
                          :name="tipoDocumento"
                          :key="tipoDocumento"
                          class="lg:w-3/4 w-full"
                          v-model="cpfCnpj"
                          v-mask="tipoDocumento === 'CPF' ? '###.###.###-##' : '##.###.###/####-##'"
                          :label="tipoDocumento"
                          icon="fa fa-user"
                          icon-pack="fa"
                          :placeholder="tipoDocumento"
                          style="width: 100%"
                          v-validate="`required|${tipoDocumento}`"
                          :class="validateState(tipoDocumento)"
                          :danger="validateClass(tipoDocumento)"
                          :danger-text="this.$validator.errors.first(tipoDocumento)"
                        ></vs-input>
                        <div class="lg:w-1/4 w-full lg:mt-0 mt-4">
                          <span class="pl-2">Tipo</span>
                          <v-select
                            class="tipoPessoaSelect"
                            v-model="tipoDocumento"
                            :options="['CPF', 'CNPJ']"
                            label="Tipo"
                            :clearable="false"
                          ></v-select>
                        </div>
                      </div>
                    </vs-col>
                    <vs-col class="m-2 flex flex-row flex-nowrap justify-center items-center w-full lg:mt-5">
                      <vs-input
                        id="placa"
                        name="placa"
                        v-model="placa"
                        label="Placa"
                        icon="fa fa-car"
                        icon-pack="fa"
                        placeholder="Placa"
                        style="width: 100%"
                        v-mask="'AAA-XXXX'"
                        v-validate="{ required: true }"
                        :class="validateState('placa')"
                        :danger="validateClass('placa')"
                        danger-text="Placa inválida"
                      ></vs-input>
                    </vs-col>
                    <vs-col class="flex flex-row flex-nowrap justify-center items-center w-full mt-5">
                      <vs-button
                        class="rounded-full"
                        color="#114880"
                        @click.stop.prevent="getBoleto()">Exibir Boletos em Aberto
                      </vs-button>
                    </vs-col>
                  </vs-row>
                </div>
                <div class="pt-10 flex flex-wrap w-full lg:px-20" v-if="this.boletos.length > 0">
                  <vs-card class="w-full py-6 boletosCard" v-for="boleto in this.boletos" :key="boleto.id_boleto">
                    <div class="flex lg:flex-row flex-col flex-nowrap justify-center items-center mb-0 gap-2">
                      <div class="flex flex-col flex-nowrap justify-around items-center w-full">
                        <p class="whitespace-nowrap font-bold">Placa</p>
                        <p>{{ boleto.placa }}</p>
                      </div>
                      <div class="flex flex-col flex-nowrap justify-around items-center w-full">
                        <p class="whitespace-nowrap font-bold">Data de Vencimento</p>
                        <p>{{ dateConversion.converteISOToDate(boleto.data_vencimento) }}</p>
                      </div>
                      <div class="flex flex-col flex-nowrap justify-around items-center w-full">
                        <p class="whitespace-nowrap font-bold">Tipo de Pagamento</p>
                        <p>{{ boleto.forma_pagamento }}</p>
                      </div>
                      <div class="flex flex-col flex-nowrap justify-around items-center w-full">
                        <p class="whitespace-nowrap font-bold">Valor</p>
                        <p>{{ formatToBRL(boleto.valor_boleto) }}</p>
                      </div>
                      <div class="flex flex-col flex-nowrap justify-around items-center w-full">
                        <p class="whitespace-nowrap font-bold capitalize">Situação</p>
                        <p>{{ boleto.situacao.toLowerCase() }}</p>
                      </div>
                      <div class="flex flex-col flex-nowrap justify-around items-center w-full">
                        <vs-button
                          class="border rounded-full no-wrap-button text-xs"
                          color="#114880"
                          type="border"
                          @click.stop.prevent="openBoleto(boleto.link_boleto)">Pagar Agora
                        </vs-button>
                      </div>
                      <div class="flex flex-col flex-nowrap justify-around items-center w-full">
                        <vs-button
                          class="border rounded-full no-wrap-button text-xs"
                          color="#114880"
                          type="border"
                          @click.stop.prevent="copiarParaAreaDeTransferencia(boleto.linha_digitavel, boleto.id_boleto)"
                          >{{ boleto.id_boleto === boletoCopiado ? 'Linha digitável copiada' : 'Copiar linha digitável' }}
                        </vs-button>
                      </div>
                    </div>
                  </vs-card>
                </div>
              </div>
            </vs-card>
          </vs-col>
        </vs-row>
      </div>
    </div>
  </div>
</template>
